import { Injectable } from '@angular/core';
import { ApiService } from '../../Service/Common/api.service';
import { StreamModel } from '../../Model/Stream/stream.model';
import { UrlHelperService } from '../../Service/Common/urlhelper.service';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {

  constructor(private _api: ApiService) { }

  GetTools()
  {
    return this._api.get(UrlHelperService.getTools);
  }
}
